// Services
import callAPI from "../callApi";
import path from "../variables";

const Embarkations = {
	getAll: (filter?: any) =>
		callAPI(
			"GET",
			`${path.base}/planning/embarkations${filter ? filter : ""}`,
			"",
			"getting all embakations"
		),
	detail: (id: number) =>
		callAPI("GET", `${path.base}/planning/embarkations/${id}`, "", "getting a specific embakation"),
	create: (data: any) =>
		callAPI("POST", `${path.base}/planning/embarkations`, data, "creating embakations"),
	update: (data: any, id: number) =>
		callAPI("PUT", `${path.base}/planning/embarkations/${id}`, data, "updating embarkation"),
	confirmDeparture: (id: number, expectedVersion?: number | null) =>
		callAPI(
			"POST",
			`${path.base}/planning/embarkations/${id}/confirm-departure`,
			expectedVersion === undefined || expectedVersion === null
				? {}
				: { expected_version: expectedVersion },
			"confirming embarkation departure"
		),
	// Endpoint groupé pour le formulaire de création — retourne en 1
	// call : travel_routes, drivers, vehicles, ticket_types, end_stations.
	// Remplace 5 GET séquentiels (~10s) par 1 GET (~2s).
	// `skipCache` : permet à l'appelant (ouverture du formulaire sur clic
	// utilisateur) de forcer un fetch frais, sans dépendre du TTL ni d'une
	// invalidation croisée — garantit que les listes (chauffeurs, véhicules…)
	// reflètent un ajout fait juste avant dans un autre écran.
	prerequisites: (stationId: number | string, skipCache = false) =>
		callAPI(
			"GET",
			`${path.base}/planning/embarkations/prerequisites/${stationId}`,
			"",
			"getting embarkation prerequisites",
			skipCache ? { skipCache: true } : undefined
		),
};

export default Embarkations;
